export enum CompanySetupEnum {
  CompanySetupHeading = 'Company Setup',
  REPORTING_DETAILS = 'reportingDetails',
  ORG_DETAILS = 'organizationDetails',
  ORG = 'Organization Details',
  LOCATIONS = 'Locations',
  ORG_MAP = 'Organization Map',
  REPORTING = 'Reporting Details',
  CloseFormHeading = 'Are you sure you want to close the form?',
  CloseFormSubHeading = 'Closing the form will result in the loss of data entered in the Organizational form.',
  NewOrganizationTitle = 'New Organization',
  NewOrganizationSubtitle = 'This organization will be considered the parent organization.',
  NewOrganizationTextDetail = 'All current and future organizations will be included under this. Changes can be made to the organization map later if needed.',
  AddParentOrgTitle = 'Add Parent Organization Details',
  CompanyDashboardEmptyStateTitle = 'Need Parent Organization details to show the dashboard',
  AddLocTitle = 'Add Location Details',
  CompanyDashboardEmptyStateSubTitle = 'Add parent organization to view the complete details of the carbon emission.',
  AddLocSubTitle = 'Incorporate location data to calculate the carbon footprint for both products and the organization.',
  AddParentOrgSubTitle = 'To get started, click the button to create your first organization. Then, follow the steps to set up your first location and calculate carbon footprints for your organization and products.',
  LocationListingPlaceholder = 'show location listing page if organization is there will handle when work on location listing',
  EQUITY_TEXT = 'Enter equity share value for each year ( unit as Percentage% )',
  ADD_LOCATION = 'Add Location',
  DASHBOARD = 'Dashboard',
  NEXT = 'Next',
  COMPLETED = 'Completed',
  INCOMPLETED = 'Incompleted',
  DELETE = 'Delete Location',
  LOCATION = 'Location',
  NEW = 'New locations',
  LOCATION_Text = 'locations',
  ORG_BOUNDARY = 'Organizational Boundary',
}
export const pageSize = 10;
export enum CompanyButtonProps {
  SUBMIT = 'Submit',
  BACK = 'Back',
}
export enum CompanySetUpTabHash {
  LOCATIONS = 'locations',
  ORG_MAP = 'organizationMap',
}

export enum OrganisationMapTitles {
  EDIT_ORGANISATION_MAP = 'Edit Map & add organization',
}
export const LocationTableStrings = {
  LOCATION_NAME: 'Location Name',
  ORGANIZATION: 'Organization',
  ORGANIZATION_BOUNDARY: 'Organization Boundary',
  TYPE: 'Type',
  ADDRESS: 'Address',
  ACTIONS: 'Status',
  COMPLETED: 'Completed',
  INCOMPLETE: 'Not Completed',
  PERCENTAGE_SIGN: '%',
};
export enum LocationTableFields {
  NAME = 'name',
  ORGANIZATION = 'organization',
  ORGANIZATION_NAME = 'name',
  SHAREERCENTAGE = 'sharePercentage',
  CATEGORY = 'category',
  ADDRESS = 'address',
  FULLADDRESS = 'full_address',
  SHAREPERCENTAGE = 'share_percentage',
  STATUS = 'is_completed',
  ASC = 'ASC',
  DESC = 'DESC',
}
export enum LocationTableProps {
  NAME_TITLE = 'Location name',
  NAME_DATA_INDEX = 'name',
  ORG = 'Organization',
  ROLE_INDEX = 'userRole',
  EMAIL_TITLE = 'Email',
  EMAIL_INDEX = 'email',
  PHONE_TITLE = 'Phone number',
  PHONE_INDEX = 'phone',
  BRAND = 'Brand',
  BRAND_INDEX = 'association',
  ACTION_TITLE = '',
  ACTION_INDEX = 'actions',
  ACTION_WIDTH = '10%',
}
interface Company {
  size: {
    id: number;
  };
  sector: {
    id: number;
  };
  sub_sector: {
    id: number;
  };
  industry_group: {
    id: number;
  };
  organizational_boundary: string;
  reporting_month: number;
  baseline_year: number;
  recalculation_threshold: number;
}

interface Organization {
  name: string;
}

export interface Payload {
  data: {
    company: Company;
    organization: Organization;
  };
}
